import React from "react";
import { NotAcceptingOrdersBannerContent } from "./notAcceptingOrdersBannerContent";
import { Merchant } from "@/dto/merchant";

export const isBusinessOpen = (merchant: Merchant): boolean => {
  const service = merchant.services.find(
    (s: any) => s.type === "PICKUP" || s.type === "WEBSITE"
  );
  if (!service || !service.enabled) {
    if (merchant.isRestaurant) {
      const curbsideService = merchant.services.find(
        (s: any) => s.type === "CURBSIDE"
      );
      const deliveryService = merchant.services.find(
        (s: any) => s.type === "DELIVERY"
      );
      if (
        (!curbsideService || !curbsideService.enabled) &&
        (!deliveryService || !deliveryService.enabled)
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  return true;
};

export const NotAcceptingOrdersBanner = ({
  merchant,
}: {
  merchant: Merchant;
}) => {
  if (!merchant) {
    return;
  }
  let isOpen = isBusinessOpen(merchant);

  if (!isOpen || !merchant.isCheckoutEnabled) {
    return <NotAcceptingOrdersBannerContent merchant={merchant} />;
  }

  return null;
};
